import type { AdminMenuRouteSource } from '@/shared/types/admin'

export type AdminMenuTranslator = (
  key: string,
  params?: Record<string, string | number>
) => string

export const isVisibleAdminMenu = (item: AdminMenuRouteSource): boolean => {
  return item.menuHide !== 1 && item.type !== 2
}

/** 保留 tools-server 返回顺序，只过滤隐藏项和按钮项。 */
export const getVisibleAdminMenus = (
  items: readonly AdminMenuRouteSource[]
): AdminMenuRouteSource[] => {
  return items.filter(isVisibleAdminMenu)
}

export const resolveAdminMenuLabel = (
  item: AdminMenuRouteSource,
  translate: AdminMenuTranslator
): string => {
  const name = item.name?.trim()
  if (name) return name
  if (item.titleKey) return translate(item.titleKey)
  return translate('admin.nav.unknownMenu')
}
